import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject, Input,
  OnInit,
  Output
} from "@angular/core";
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";
import {viewSettingsServiceProvider} from "../../../../../providers";
import {
  ViewSettingsHolderType,
  ViewSettingsModel,
  ViewSettingsType
} from "../../../../commons/models/view-settings.model";
import {PlanningProjectsService} from "../../../services/planning-projects-service.service";

interface PlanningProjectDraftSelectListModel {
  selectedDraftId: string;
  projectId: string;
  drafts: any[];
  defaultDraftId: string;
}

require('./planning-project-draft-select-list.scss');
@Component({
  standalone: false,
  selector: 'app-planning-project-draft-select-list',
  templateUrl: './planning-project-draft-select-list.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningProjectDraftSelectListComponent implements OnInit {

  @Output() onClose = new EventEmitter<any>();

  public selectedDraftId: string;
  public drafts: any[];
  public draftsCopy: any[];
  public queryString: string = '';
  public projectId: string;
  public defaultDraftId: any;

  constructor(@Inject(PANEL_DATA) public data: PlanningProjectDraftSelectListModel,
              @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef, @Inject('planningProjectsService') private planningProjectsService) {
  }

  ngOnInit() {
    this.projectId = this.data.projectId;
    this.selectedDraftId = this.data.selectedDraftId;
    this.defaultDraftId = this.data.defaultDraftId;
    this.drafts = [...this.data.drafts];
    this.draftsCopy = [...this.data.drafts];
  }

  onSelect(draftId: string) {
    this.onClose.emit({selectedDraftId: draftId});
  }

  onQueryChange(query) {
    this.queryString = query;
    this.draftsCopy = this.drafts.filter(draft => draft.name.toLowerCase()?.includes(query.toLowerCase()));
  }

  onSetDraftAsDefault(draftId: string) {
    this.planningProjectsService.setSelectedDraft(this.projectId, draftId)
      .then(() => {
        this.defaultDraftId = draftId;
        this.cdr.detectChanges();
      })
  }

}
